import categories from "./categories";

export default {
    categories
}
